import { withRxJs } from '../../components/hoc/with-rx';
import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { YourAnalysisComponent } from './analysis.component';
import { AnalysisApi } from '../../apis/analysis.api';
import { TLeadRiskResponse } from '../../models/lead-risk-response';
import { RiskApi } from '../../apis/risk.api';
import { TAnalysisAccountDetailResponse } from '../../models/analysis-account-details.model';
import { TAdvisorContractResponse } from '../../models/advisor-contract.model';

export const YourAnalysisContainer = withRxJs(YourAnalysisComponent)(() => {
	const images$ = AnalysisApi.getRiskToleranceImages();
	const imagesStatic$ = AnalysisApi.getFinancialImages();

	return {
		defaultProps: {
			leadRisk: {} as TLeadRiskResponse,
			riskToleranceImages: RemoteDataUtils.initial,
			staticImagesUrls: RemoteDataUtils.initial,
			goalAccountDetails: {} as TAnalysisAccountDetailResponse,
			advisorDetails: {} as TAdvisorContractResponse,
			savedPdfUrl: "",
			getGoalDetailsOnLoad: (leadStrategyId: string, agentId: string) => {
                AnalysisApi.getGoalDetailsForAnalysis(leadStrategyId, agentId);
            },
			getAdvisorContractDetailsOnLoad: (agentId: string) => {
                AnalysisApi.getAdvisorContractDetails(agentId);
            },
			saveLoadPdf: (leadId: string, agentId: string, pages: string[]) => {
				AnalysisApi.saveLeadPdf(leadId, agentId, pages);
			},
		},
		props: {
			riskToleranceImages: images$,
			staticImagesUrls: imagesStatic$,
			advisorDetails: AnalysisApi.advisorContractDetails$,
			leadRisk: RiskApi.getLeadRiskProfile$(),
			goalAccountDetails: AnalysisApi.goalAccountDetails$,
			savedPdfUrl: AnalysisApi.savedPdfUrl$
		},
	};
});
